import { Message } from 'primeng/api';
import { Severity } from '../../shared/enums/severity';

export class DisplayMessage implements Message {
  public severity: 'success' | 'warn' | 'error' | 'info';

  constructor(
    public summary: string,
    public detail: string,
    severity: Severity,
  ) {
    switch (severity) {
      case Severity.Success:
        this.severity = 'success';
        break;

      case Severity.Warning:
        this.severity = 'warn';
        break;

      case Severity.Error:
        this.severity = 'error';
        break;

      default:
        this.severity = 'info';
        break;
    }
  }
}
